﻿module PortalLibs.Client.Cmd

open Elmish

module OfAsyncFromTask =
  let either task =
    Cmd.OfAsync.either (task |> Async.castTask)

  let attempt task =
    Cmd.OfAsync.attempt (task |> Async.castTask)
    
  let perform task =
    Cmd.OfAsync.perform (task |> Async.castTask)